/**
 * The Tally form in the "Tell us what to build next" section, by the end of
 * its tally.so/r/ link. Undefined hides the section.
 */
export const WHATS_NEW_FEEDBACK_FORM_ID: string | undefined = 'xXeY6k';

export const FEEDBACK_SECTION_ID = 'feedback';

const TALLY_EMBED_BASE_URL = 'https://tally.so/embed/';

// Left-aligned, untitled and transparent so the form sits in the page, and
// sized by Tally's embed script to fit the form.
const TALLY_EMBED_OPTIONS = {
  alignLeft: '1',
  hideTitle: '1',
  transparentBackground: '1',
  dynamicHeight: '1'
};

/**
 * Tally reads hidden fields from the query string and keeps only the ones the
 * form declares. Never pass emails or FPL IDs: the form asks for contact
 * details itself.
 */
export const buildFeedbackEmbedUrl = (
  hiddenFields: Record<string, string>,
  formId: string | undefined
): string | undefined => {
  if (!formId) return undefined;
  const url = new URL(`${TALLY_EMBED_BASE_URL}${formId}`);
  Object.entries({ ...TALLY_EMBED_OPTIONS, ...hiddenFields }).forEach(
    ([key, value]) => url.searchParams.set(key, value)
  );
  return url.toString();
};
